module.exports = __webpack_public_path__ + "static/nyoutritious-1-ec4c46b146d9f896bf70ea9e1851a679.gif";